import React, { Component } from 'react';
import { DateRange } from 'react-date-range';

//import {es} from 'date-fns/locale';
import { es } from 'react-date-range/src/locale/index.js'
import { addDays, addMonths } from 'date-fns';

import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file

import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
//import ListItemText from '@material-ui/core/ListItemText';
import Button from '@material-ui/core/Button';
import Popover from '@material-ui/core/Popover';

import moment from 'moment'
import 'moment/locale/es'
moment.locale('es')


class Step extends Component {
    constructor(props) {
        super(props);
        //console.log('steps', props)
        this.state = {
            steps:this.props.steps,
            step:this.props.step
        }
        
    }

    createStep=()=>{
        const { open ,steps, step} = this.state;
        //console.log(step)
        //console.log(steps)
        var newSteps=(steps.filter(i=>i.nombre_paso!==step))
        var stepData=
            <List >
                {(newSteps).map(i => (
                    <ListItem style={{paddingLeft:"0px"}}
                    >
                        <ListItemIcon
                        />
                        <Button id={i.id_paso} name={i.nombre_paso} onClick={() => Graph(this.props, this.state,i)}>{i.nombre_paso}</Button> 
                    </ListItem>))}
            </List>
        
        return stepData
    }
    
    render() {
        const { open } = this.state;
        //console.log('render props', this.props)
        return (
            this.createStep()
        )
    }
}

function Graph(props, state, id) {
    //console.log('graph', props, state, id)
    props.onClick(id)
}


export default Step;